@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';

.note-tooltip-time {
  font-size: 12px;
  line-height: 14px;
  color: @note-tooltip--time--text-color;
}

.date-separator {
  margin: 0 4px;
}
